import { useMemo, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { MaterialMapping } from "~/pages/Admin/Mapping/Materials/MaterialMapping"
import { useFindMappingByTypeQuery } from "~/pages/Admin/Mapping/hooks/useFindMappingByTypeQuery"
import {
  DEFAULT_PAGE_SIZE,
  MappingCollapseProps,
  MappingTypeNames,
} from "~/pages/Admin/Mapping/types"

type MaterialMappingWrapperProps = MappingCollapseProps

export const MaterialMappingWrapper = ({
  isOpen,
  close,
  open,
}: MaterialMappingWrapperProps) => {
  const [page, setPage] = useState<number>(1)

  const [search, setSearch] = useState<string>("")

  const query = useFindMappingByTypeQuery(MappingTypeNames.MATERIAL, {
    page,
    search,
  })

  const totalPages = useMemo<number>(
    () =>
      query.data?.data.total
        ? Math.ceil(query.data.data.total / DEFAULT_PAGE_SIZE)
        : 0,
    [query.data?.data.total]
  )

  return (
    <DataFetchWrapper query={query} acceptEmpty>
      {({ data }) => (
        <MaterialMapping
          materialTypes={data.data.mappings}
          pagination={{
            totalPages,
            currentPage: page,
            onPageChange: setPage,
          }}
          search={search}
          setSearch={setSearch}
          isOpen={isOpen}
          close={close}
          open={open}
        />
      )}
    </DataFetchWrapper>
  )
}
